import { Button, Result } from 'antd'

import { classNames } from '@/Ship/Helpers/classNames'

import styles from './ErrorScreen.module.css'

interface ErrorScreenProps {
    /** Картинка легасі з `public/assets/errors/`. */
    image: string
    title: string
    subTitle?: string
    /** «На головну» — куди вести; за замовчуванням повне перезавантаження на `/`. */
    onHome?: () => void
}

/**
 * Екран помилки Астерікса — 404 і 403 (`SPEC-014` §2.3, §2.4): картинка легасі,
 * заголовок і «На головну».
 *
 * Кольори — лише з теми antd (`Result`) і змінних: екран має однаково
 * читатися у світлій і темній темі. Тло 404 легасі (`#fff4f0`) прибрано з
 * самої картинки — у темній темі воно було б світлим квадратом.
 */
export const ErrorScreen = ({ image, title, subTitle, onHome }: ErrorScreenProps) => (
    <div className={classNames(styles['screen'])}>
        <Result
            icon={<img className={classNames(styles['image'])} src={image} alt="" aria-hidden />}
            title={title}
            {...(subTitle ? { subTitle } : {})}
            extra={
                <Button type="primary" onClick={onHome ?? (() => (window.location.href = '/'))}>
                    На головну
                </Button>
            }
        />
    </div>
)
